(function () {
  'use strict';
  if (window.BplCollection01) {
    window.BplCollection01.init(document);
    return;
  }
  // Insert inside the collection asset's IIFE, before init().
  var bplcHighlightStates = new WeakMap();
  function bplcHighlightHeading(root) {
    var heading = root.querySelector('.bplc-hero__copy h1');
    if (!heading) return;
    var title = heading.textContent;
    var raw = heading.getAttribute('data-bplc-highlight-phrases');
    var previous = bplcHighlightStates.get(heading);
    if (previous && previous.title === title && previous.raw === raw) return;

    // Bounds protect enhancement work; an oversized input keeps the full plain title.
    var phrases = [];
    if (title.length <= 4096 && raw && raw.length <= 65536) {
      try {
        var value = JSON.parse(raw);
        if (Array.isArray(value) && value.length <= 128) {
          value.forEach(function (phrase) {
            if (typeof phrase !== 'string' || phrase.trim() === '' || phrase.length > title.length) return;
            if (phrases.indexOf(phrase) === -1) phrases.push(phrase);
          });
        }
      } catch (error) { /* Invalid optional data leaves the ordinary title readable. */ }
    }

    // Difference counts merge every literal match, including overlaps and adjacency.
    var coverage = new Int32Array(title.length <= 4096 ? title.length + 1 : 0);
    var matched = false;
    phrases.forEach(function (phrase) {
      var start = title.indexOf(phrase);
      while (start !== -1) {
        coverage[start] += 1;
        coverage[start + phrase.length] -= 1;
        matched = true;
        start = title.indexOf(phrase, start + 1);
      }
    });

    if (matched) {
      var fragment = heading.ownerDocument.createDocumentFragment();
      var depth = 0;
      var runStart = 0;
      var highlighted = false;
      function appendRun(end) {
        if (end === runStart) return;
        var text = heading.ownerDocument.createTextNode(title.slice(runStart, end));
        if (highlighted) {
          var span = heading.ownerDocument.createElement('span');
          span.className = 'bplc-title-highlight';
          span.appendChild(text);
          fragment.appendChild(span);
        } else fragment.appendChild(text);
      }
      for (var index = 0; index < title.length; index += 1) {
        depth += coverage[index];
        var nextHighlighted = depth > 0;
        if (nextHighlighted !== highlighted) {
          appendRun(index);
          runStart = index;
          highlighted = nextHighlighted;
        }
      }
      appendRun(title.length);
      heading.replaceChildren(fragment);
    } else if (previous && previous.highlighted) {
      heading.replaceChildren(heading.ownerDocument.createTextNode(title));
    }
    bplcHighlightStates.set(heading, { title: title, raw: raw, highlighted: matched });
  }

  var bplcFilterStates = new WeakMap();
  function bplcPreserveMissingFilters(form) {
    if (!form) return;
    var represented = Object.create(null);
    form.querySelectorAll('[name]').forEach(function (input) { represented[input.name] = true; });
    var current = new URL(window.location.href);
    current.searchParams.forEach(function (value, name) {
      if (!/^filter\.(p|v)\..+/.test(name) || represented[name]) return;
      var input = form.ownerDocument.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value;
      input.setAttribute('data-bplc-preserved-filter', '');
      form.appendChild(input);
    });
  }
  function bplcPreservedFilterCount(form) {
    var count = 0, seen = [];
    var priceName = /^filter\.(p|v)\.price\.(gte|lte)$/;
    var hasPrice = Array.prototype.some.call(form.querySelectorAll('input[type="number"]'), function (input) {
      return priceName.test(input.name) && input.value !== '';
    });
    form.querySelectorAll('[data-bplc-preserved-filter]').forEach(function (input) {
      if (input.disabled || input.value === '' || seen.some(function (entry) { return entry.name === input.name && entry.value === input.value; })) return;
      seen.push({ name: input.name, value: input.value });
      if (priceName.test(input.name)) { if (!hasPrice) count += 1; hasPrice = true; }
      else count += 1;
    });
    return count;
  }
  function bplcEnhanceFilters(root, form) {
    bplcPreserveMissingFilters(form);
    var existing = bplcFilterStates.get(root);
    if (existing) { existing.update(); return existing; }
    var browser = form && form.querySelector('[data-bplc-filter-browser]');
    var tabs = browser && browser.querySelector('[data-bplc-filter-tabs]');
    if (!browser || !tabs) return null;
    var panes = Array.prototype.slice.call(browser.querySelectorAll('[data-bplc-filter-panel]'));
    if (!panes.length || panes.length > 100) return null;
    var keys = [], ids = [];
    var complete = panes.every(function (pane) {
      var key = pane.getAttribute('data-bplc-filter-key');
      var label = pane.getAttribute('data-bplc-filter-label');
      if (!key || !label || !pane.id || keys.indexOf(key) !== -1 || ids.indexOf(pane.id) !== -1) return false;
      keys.push(key); ids.push(pane.id); return true;
    });
    if (!complete) return null;

    var status = form.querySelector('[data-bplc-selection-status]');
    var totalCounter = form.querySelector('[data-bplc-filter-total]');
    var owner = root.ownerDocument;
    var fragment = owner.createDocumentFragment();
    var groups = panes.map(function (pane, index) {
      var button = owner.createElement('button');
      button.type = 'button';
      button.className = 'bplc-filter-category';
      button.id = pane.id + '-tab';
      button.setAttribute('role', 'tab');
      button.setAttribute('aria-controls', pane.id);
      var label = owner.createElement('span');
      label.className = 'bplc-filter-category__label';
      label.textContent = pane.getAttribute('data-bplc-filter-label');
      var count = owner.createElement('span');
      count.className = 'bplc-filter-category__count';
      count.setAttribute('aria-hidden', 'true');
      button.appendChild(label); button.appendChild(count); fragment.appendChild(button);
      return { pane: pane, key: keys[index], label: label.textContent, button: button, counter: count };
    });
    var storageKey = 'bplc-filter-tab:' + window.location.pathname + ':' + (root.getAttribute('data-section-id') || root.id || 'collection');
    var active = 0;
    function selectedCount(group) {
      var count = 0;
      group.pane.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (input) { if (input.checked) count += 1; });
      var hasPrice = Array.prototype.some.call(group.pane.querySelectorAll('input[type="number"]'), function (input) { return input.value !== ''; });
      return count + (hasPrice ? 1 : 0);
    }
    function activate(index, focus, remember) {
      active = index;
      groups.forEach(function (group, i) {
        var selected = i === index;
        group.button.setAttribute('aria-selected', String(selected));
        group.button.tabIndex = selected ? 0 : -1;
        group.pane.hidden = !selected;
      });
      if (remember) {
        try { window.sessionStorage.setItem(storageKey, groups[index].key); } catch (error) { /* Storage is optional. */ }
      }
      if (focus) groups[index].button.focus();
    }
    function update() {
      var total = bplcPreservedFilterCount(form);
      groups.forEach(function (group) {
        var count = selectedCount(group); total += count;
        group.counter.textContent = count ? String(count) : '';
        group.counter.hidden = !count;
        group.button.setAttribute('aria-label', group.label + (count ? ', ' + count + ' selected' : ''));
      });
      if (status) status.textContent = total ? total + (total === 1 ? ' filter selected' : ' filters selected') : 'No filters selected';
      if (totalCounter) { totalCounter.textContent = String(total); totalCounter.hidden = !total; }
    }
    var stored = null;
    try { stored = window.sessionStorage.getItem(storageKey); } catch (error) { /* Native controls remain usable without storage. */ }
    var remembered = keys.indexOf(stored);
    if (remembered !== -1) active = remembered;
    else {
      for (var i = 0; i < groups.length; i += 1) {
        if (selectedCount(groups[i])) { active = i; break; }
      }
    }
    groups.forEach(function (group, index) {
      group.pane.setAttribute('role', 'tabpanel');
      group.pane.setAttribute('aria-labelledby', group.button.id);
      group.pane.tabIndex = 0;
      group.button.addEventListener('click', function () { activate(index, false, true); });
      group.button.addEventListener('keydown', function (event) {
        var next = null;
        if (event.key === 'ArrowDown') next = (index + 1) % groups.length;
        else if (event.key === 'ArrowUp') next = (index + groups.length - 1) % groups.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = groups.length - 1;
        if (next === null) return;
        event.preventDefault(); activate(next, true, true);
      });
    });
    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', 'Filter categories');
    tabs.setAttribute('aria-orientation', 'vertical');
    tabs.replaceChildren(fragment);
    activate(active, false, false);
    update();
    tabs.hidden = false;
    if (status) { status.hidden = false; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); }
    browser.dataset.bplcFilterBrowserReady = 'true';
    form.addEventListener('change', update);
    form.addEventListener('input', update);
    var state = { update: update, reveal: function (input) {
      for (var i = 0; i < groups.length; i += 1) {
        if (groups[i].pane.contains(input)) { activate(i, false, true); return; }
      }
    } };
    bplcFilterStates.set(root, state);
    return state;
  }
  function bplcConnectHelp(root, form, filterBrowser, details, help) {
    if (!help || !details || !form) return;
    var targets = Array.prototype.slice.call(form.querySelectorAll('[data-bplc-help-key]'));
    help.querySelectorAll('[data-bplc-help-target]').forEach(function (button) {
      var key = button.getAttribute('data-bplc-help-target');
      var matches = targets.filter(function (target) { return target.getAttribute('data-bplc-help-key') === key; });
      if (matches.length !== 1 || button.getAttribute('aria-controls') !== matches[0].id) return;
      var target = matches[0];
      button.hidden = false;
      button.addEventListener('click', function () {
        // Reveal the existing native group. No values change and no form is sent.
        if (!form.contains(target)) return;
        details.open = true;
        if (filterBrowser) filterBrowser.reveal(target);
        help.open = false;
        var legend = target.querySelector('legend');
        if (legend) {
          legend.tabIndex = -1;
          legend.focus();
          legend.scrollIntoView({ block: 'nearest' });
        } else details.querySelector('summary').focus();
      });
    });
  }
  function init(scope) {
    var roots = [];
    if (scope.matches && scope.matches('[data-bpl-collection]')) roots.push(scope);
    roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-bpl-collection]')));
    roots.forEach(function (root) {
      bplcHighlightHeading(root);
      if (root.dataset.bplcReady === 'true') return;
      var form = root.querySelector('[data-bplc-form]');
      if (!form) return;
      root.dataset.bplcReady = 'true';
      root.classList.add('is-ready');
      var filterBrowser = bplcEnhanceFilters(root, form);
      var details = root.querySelector('.bplc-filters');
      var help = root.querySelector('.bplc-help');
      bplcConnectHelp(root, form, filterBrowser, details, help);
      if (help) help.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && help.open) {
          help.open = false;
          help.querySelector('summary').focus();
        }
      });
      var sort = root.querySelector('[data-bplc-sort]');
      var prices = Array.prototype.slice.call(form.querySelectorAll('input[type="number"]'));
      var current = new URL(window.location.href);
      ['preview_theme_id', '_fd', 'pb'].forEach(function (name) {
        if (!current.searchParams.has(name)) return;
        var input = document.createElement('input');
        input.type = 'hidden'; input.name = name; input.value = current.searchParams.get(name);
        form.appendChild(input);
      });
      function validatePrices() {
        prices.forEach(function (input) { input.setCustomValidity(''); });
        for (var i = 0; i < prices.length; i += 2) {
          var min = prices[i], max = prices[i + 1];
          if (min && max && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value)) {
            max.setCustomValidity('Enter a maximum price greater than or equal to the minimum.');
          }
        }
      }
      prices.forEach(function (input) { input.addEventListener('input', validatePrices); });
      form.addEventListener('invalid', function (event) {
        if (details && details.contains(event.target)) details.open = true;
        if (filterBrowser) filterBrowser.reveal(event.target);
      }, true);
      form.addEventListener('submit', function (event) {
        validatePrices();
        if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
        // Empty price endpoints are absent parameters, never accidental zeroes.
        prices.forEach(function (input) { if (input.value === '') input.disabled = true; });
        // Native GET navigation remains in charge of results and browser history.
        root.setAttribute('aria-busy', 'true');
      });
      if (sort) sort.addEventListener('change', function () {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.querySelector('[type="submit"]').click();
      });
      if (details) details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && details.open) {
          details.open = false;
          details.querySelector('summary').focus();
        }
      });
      root.querySelectorAll('[data-bplc-collection-link]').forEach(function (link) {
        var url = new URL(link.href, window.location.href);
        if (url.origin !== window.location.origin) return;
        url.searchParams.set('view', 'bpl-01');
        ['preview_theme_id', '_fd', 'pb'].forEach(function (name) {
          if (current.searchParams.has(name)) url.searchParams.set(name, current.searchParams.get(name));
        });
        link.href = url.pathname + url.search + url.hash;
      });
    });
  }
  window.BplCollection01 = { init: init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-bpl-collection]').forEach(function (root) {
      root.removeAttribute('aria-busy');
      var filterBrowser = bplcFilterStates.get(root);
      if (filterBrowser) filterBrowser.update();
      root.querySelectorAll('[data-bplc-form] input[type="number"]').forEach(function (input) { input.disabled = false; });
    });
  });
})();
